declare global {
  interface Window {
    ENV_GRAPHQL_URI: string;
    ENV_AUTH_URI: string;
    ENV_REST_URI: string;
    ENV_BUILDING_MASTER_APP_URI: string;
    ENV_ACCOUNT_APP_URI: string;
    ENV_APPLICATIONINSIGHTS_CONNECTION_STRING: string;
    ENV_CONNECT_APP_URI: string;
  }
}

export const GRAPHQL_URI = window.ENV_GRAPHQL_URI;
export const AUTH_URI = window.ENV_AUTH_URI;
export const REST_URI = window.ENV_REST_URI;
export const BUILDING_MASTER_APP_URI = window.ENV_BUILDING_MASTER_APP_URI;
export const ACCOUNT_APP_URI = window.ENV_ACCOUNT_APP_URI;
export const APPLICATIONINSIGHTS_CONNECTION_STRING =
  window.ENV_APPLICATIONINSIGHTS_CONNECTION_STRING;
export const CONNECT_APP_URI = window.ENV_CONNECT_APP_URI;

// same for all environments
export const CLIENT_ID = 'admin-app';
